import http from '../libs/http'

let actions = {
		baseName(state, str) {
				var base = new String(str).substring(str.lastIndexOf('/') + 1);
				if(base.lastIndexOf(".") != -1)
						base = base.substring(0, base.lastIndexOf("."));
				return base;
		},
		async getUserProjects({commit, state}, options) {
				let sort_by = options.sort_by ? options.sort_by : 'updated_at';
				let sort_type = options.sort_type ? options.sort_type : 'desc';
				let limit = options.limit ? options.limit : 10;
				let page = options.page ? options.page : 1;

				if (options.company) {
					let data = http.route('project?filters[company_id]=' + options.company + '&page='+ page +'&sort_by='+ sort_by+ '&sort_order='+ sort_type+ '&limit='+limit).get();
					return data.then(res => {
							return res;
					});
				} else {
					let data = http.route('project?page='+ page +'&sort_by='+ sort_by+ '&sort_order='+ sort_type+ '&limit='+limit).get();
					return data.then(res => {
							return res;
					});
				}
		},
		async getProjectInfo({commit, state}, id) {
				let data = http.route('project/' + id).get();
				return data.then(res => {
						return res.data;
				});
		},
		async getIsoInfo({commit, state}, id) {
				let data = http.route('drawing/' + id).get();
				return data.then(res => {
						return res.data;
				});
		},
		async getCompanyInfo({commit, state}, id) {
				let data = http.route('company/' + id).get();
				return data.then(res => {
						return res.data;
				});
		},
		async getLanguages({commit, state}) {
				return http.route("constants/languages").get().then(response => {
						commit('SET_CONSTANTS', {'languages': response.data});

						return response;
				});
		},
		async getUserCompanies({commit, state}) {
				let userCompanies = [];

				if (typeof(state.user.user) != 'undefined' && sessionStorage.getItem('jwt')) {
					let data = http.route('company').get();
					data.then(async res => {
							if (!res.isError) {
									for (var i = 0; i < res.data.length; i++) {
											userCompanies[i] = res.data[i];
											userCompanies[i].projects = [];

											var result = await store.dispatch('getCompanyProjects', {company: res.data[i].id, page: 0, 'order_by': 'updated_at', 'order_type': 'desc'}).then(proj => {
												userCompanies[i].projects = proj
											});
									}
							}
					});
				}

				return userCompanies;
		}
}

export default actions



// WEBPACK FOOTER //
// ./src/store/actions.js